import { AnimatePresence } from 'framer-motion'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useGetNewsTypes, useNewsFeed } from '../../api/hooks/use.news'
import { IShortNews, newsService } from '../../api/service/news.service'
import { HeadingComponent } from '../../components/ui/heading.component'
import LoaderComponent from '../../components/ui/loader.component'
import PaginationComponent from '../../components/ui/pagination.component'
import useWindowWidth from '../../utils/use.window.width'
import FilterIcon from './../../styles/icons/filter-icon.svg'
import NewsFiltersComponent from './news.filter.component'
import * as styled from './styled'

function NewsPage() {
	const [isFiltersOpen, setIsFiltersOpen] = useState<boolean>(false)
	const [currentPage, setCurrentPage] = useState<number>(1)
	const [selectedTypes, setSelectedTypes] = useState<string[]>([])

	const windowWidth = useWindowWidth()
	const itemsPerPage = windowWidth <= 630 ? 3 : 6

	const { data: newsTypes } = useGetNewsTypes()

	const { data: newsResponse, isLoading } = useNewsFeed(
		currentPage,
		itemsPerPage,
		selectedTypes.length > 0 ? selectedTypes.join(',') : undefined,
	)

	const newsData = newsResponse?.data || []
	const totalPages = newsResponse?.meta?.totalPages || 1
	const hasNews = newsData.length > 0
	const selectedCount = selectedTypes.length

	useEffect(() => {
		setCurrentPage(1)
	}, [itemsPerPage, selectedTypes])

	return (
		<styled.NewsPageContainer>
			<HeadingComponent
				title={<>Новини</>}
				description='На цій сторінці розміщується оперативна інформація про роботу Контакт-Центру, виконання важливих міських робіт, попередження про аварійні ситуації та інші корисні повідомлення для мешканців'
				breadcrumbs={[
					{ title: 'Головна', path: '/' },
					{ title: 'Новини', path: '/news' },
				]}
			/>

			<styled.OpenFiltersBtn onClick={() => setIsFiltersOpen(true)}>
				<img src={FilterIcon} alt='filter-icon' />
				Тип новин
				{selectedCount > 0 ? (
					<styled.FiltersCountNumber>
						({selectedCount})
					</styled.FiltersCountNumber>
				) : (
					<styled.TrailingArrow $dir='down' />
				)}
			</styled.OpenFiltersBtn>

			<AnimatePresence>
				{isFiltersOpen && (
					<NewsFiltersComponent
						onClose={() => setIsFiltersOpen(false)}
						selectedTypes={selectedTypes}
						onApply={setSelectedTypes}
						newsTypes={newsTypes}
					/>
				)}
			</AnimatePresence>

			<styled.NewsPageContent>
				{isLoading ? (
					<styled.NewsCardsList>
						<LoaderComponent />
					</styled.NewsCardsList>
				) : hasNews ? (
					<styled.NewsCardsList>
						{newsData.map((item: IShortNews) => (
							<styled.NewsCardItem key={item.id}>
								<Link to={`/news/${item.id}`}>
									<styled.CardImg
										src={newsService.getImageUrl(item.headerImgId || '')}
										alt={item.titleUa}
									/>
								</Link>
								<styled.CardContent>
									<styled.CardDate>{item.createDate}</styled.CardDate>
									<styled.CardTitle to={`/news/${item.id}`}>
										{item.titleUa}
									</styled.CardTitle>
								</styled.CardContent>
							</styled.NewsCardItem>
						))}
					</styled.NewsCardsList>
				) : (
					<styled.NoNewsMessage>
						За запитом нічого не знайдено.
					</styled.NoNewsMessage>
				)}

				{!isLoading && hasNews && (
					<PaginationComponent
						totalPages={totalPages}
						currentPage={currentPage}
						onPageChange={setCurrentPage}
					/>
				)}
			</styled.NewsPageContent>
		</styled.NewsPageContainer>
	)
}

export default NewsPage
